import React from "react";
import { Col, Row, Tag, Flex } from "antd";
import dayjs from "dayjs";
import { formatIndianCurrency } from "../../../../../utills/helpers";

const Step4DetailsSection = ({ leadViewDetails, renderFileLinks }) => {
  const interiorDetail =
    leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail;
  const vehicleDetail = leadViewDetails?.exchange_vehicle_detail;
  const formatValue = (value, type = "text") => {
    if (value === null || value === undefined || value === "") {
      return <p className="value">-</p>;
    }

    switch (type) {
      case "currency":
        return <p>{formatIndianCurrency(value)}</p>;
      case "date":
        return <p className="value">{dayjs(value).format("DD/MM/YYYY")}</p>;
      case "boolean":
        return (
          <Tag
            color={
              value === "Yes" ? "green" : value === "No" ? "red" : "default"
            }
            style={{ fontSize: "10px", margin: 0 }}
          >
            {value}
          </Tag>
        );
      case "array":
        return Array.isArray(value) ? (
          value.map((item, index) => (
            <Tag key={index} style={{ fontSize: "10px", margin: "2px" }}>
              {item}
            </Tag>
          ))
        ) : (
          <p className="value">{value}</p>
        );
      default:
        return <p className="value">{value}</p>;
    }
  };

  const DetailItem = ({
    label,
    value,
    type = "text",
    cost = null,
    files = null,
  }) => (
    <Flex align="start" vertical>
      <Flex align="center" className="view-fields test1 w-100">
        <h6>{label}:</h6>
        {formatValue(value, type)}
      </Flex>
      {cost >= 0 && (
        <Flex className=" w-100">
          <Flex align="center" className="view-fields test2 w-100">
            <h6>Cost:</h6>
            <Flex align="center" gap={10} className="value">
              {formatValue(cost, "currency")}
              {files && renderFileLinks(files, false)}
            </Flex>
          </Flex>
        </Flex>
      )}
    </Flex>
  );

  return (
    <div style={{ padding: "16px 0" }}>
      <Row gutter={[24, 24]}>
        {/* Section 1 - Vehicle Performance & Safety (10 fields) */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Abnormal Noise"
            value={interiorDetail?.abnormal_noise}
            type="boolean"
            cost={
              interiorDetail?.abnormal_noise === "Yes"
                ? interiorDetail?.abnormal_noise_cost
                : null
            }
            files={
              interiorDetail?.abnormal_noise === "Yes"
                ? ["Abnormal Noise"]
                : null
            }
          />
          <DetailItem
            label="Pedal Handling Defect"
            value={interiorDetail?.pedal_handling_defect}
            type="boolean"
            cost={
              interiorDetail?.pedal_handling_defect === "Yes"
                ? interiorDetail?.pedal_handling_defect_cost
                : null
            }
            files={
              interiorDetail?.pedal_handling_defect === "Yes"
                ? ["Pedal Handling Defect"]
                : null
            }
          />
          <DetailItem
            label="Alignment"
            value={interiorDetail?.alignment}
            type="boolean"
            cost={
              interiorDetail?.alignment === "Yes"
                ? interiorDetail?.alignment_cost
                : null
            }
            files={interiorDetail?.alignment === "Yes" ? ["Alignment"] : null}
          />
          <DetailItem
            label="Shock Absorber Defect"
            value={interiorDetail?.shock_absorber_defect}
            type="boolean"
            cost={
              interiorDetail?.shock_absorber_defect === "Yes"
                ? interiorDetail?.shock_absorber_defect_cost
                : null
            }
            files={
              interiorDetail?.shock_absorber_defect === "Yes"
                ? ["Shock Absorber Defect"]
                : null
            }
          />
          <DetailItem
            label="Seat Belt Lock"
            value={interiorDetail?.seat_belt_lock}
            type="boolean"
            cost={
              interiorDetail?.seat_belt_lock === "Yes"
                ? interiorDetail?.seat_belt_lock_cost
                : null
            }
            files={
              interiorDetail?.seat_belt_lock === "Yes"
                ? ["Seat Belt Lock"]
                : null
            }
          />
          <DetailItem
            label="Drive Mode Faulty"
            value={interiorDetail?.drive_mode_faulty}
            type="boolean"
            cost={
              interiorDetail?.drive_mode_faulty === "Yes"
                ? interiorDetail?.drive_mode_faulty_cost
                : null
            }
            files={
              interiorDetail?.drive_mode_faulty === "Yes"
                ? ["Drive Mode Faulty"]
                : null
            }
          />
          <DetailItem
            label="Lane Assist Defect"
            value={interiorDetail?.lane_assist_defect}
            type="boolean"
            cost={
              interiorDetail?.lane_assist_defect === "Yes"
                ? interiorDetail?.lane_assist_defect_cost
                : null
            }
            files={
              interiorDetail?.lane_assist_defect === "Yes"
                ? ["Lane Assist Defect"]
                : null
            }
          />
          <DetailItem
            label="Hill Assist Defect"
            value={interiorDetail?.hill_assist_defect}
            type="boolean"
            cost={
              interiorDetail?.hill_assist_defect === "Yes"
                ? interiorDetail?.hill_assist_defect_cost
                : null
            }
            files={
              interiorDetail?.hill_assist_defect === "Yes"
                ? ["Hill Assist Defect"]
                : null
            }
          />
          <DetailItem
            label="Replaced Front Door Panel"
            value={interiorDetail?.replaced_front_door_panel}
            cost={
              interiorDetail?.replaced_front_door_panel &&
              interiorDetail?.replaced_front_door_panel !== "No"
                ? interiorDetail?.replaced_front_door_panel_cost
                : null
            }
            files={
              interiorDetail?.replaced_front_door_panel &&
              interiorDetail?.replaced_front_door_panel !== "No"
                ? ["Replaced Front Door Panel"]
                : null
            }
          />
          <DetailItem
            label="Replaced Rear Door Panel"
            value={interiorDetail?.replaced_rear_door_panel}
            cost={
              interiorDetail?.replaced_rear_door_panel &&
              interiorDetail?.replaced_rear_door_panel !== "No"
                ? interiorDetail?.replaced_rear_door_panel_cost
                : null
            }
            files={
              interiorDetail?.replaced_rear_door_panel &&
              interiorDetail?.replaced_rear_door_panel !== "No"
                ? ["Replaced Rear Door Panel"]
                : null
            }
          />
          <DetailItem
            label="Replaced Front Fender Panel"
            value={interiorDetail?.replaced_front_fender_panel}
            cost={
              interiorDetail?.replaced_front_fender_panel &&
              interiorDetail?.replaced_front_fender_panel !== "No"
                ? interiorDetail?.replaced_front_fender_panel_cost
                : null
            }
            files={
              interiorDetail?.replaced_front_fender_panel &&
              interiorDetail?.replaced_front_fender_panel !== "No"
                ? ["Replaced Front Fender Panel"]
                : null
            }
          />
          <DetailItem
            label="Replaced Bonnet Hood Panel"
            value={interiorDetail?.replaced_bonnet_hood_panel}
            cost={
              interiorDetail?.replaced_bonnet_hood_panel &&
              interiorDetail?.replaced_bonnet_hood_panel !== "No"
                ? interiorDetail?.replaced_bonnet_hood_panel_cost
                : null
            }
            files={
              interiorDetail?.replaced_bonnet_hood_panel &&
              interiorDetail?.replaced_bonnet_hood_panel !== "No"
                ? ["Replaced Bonnet Hood Panel"]
                : null
            }
          />
          <DetailItem
            label="Replaced Trunk Hood Panel"
            value={interiorDetail?.replaced_trunk_hood_panel}
            cost={
              interiorDetail?.replaced_trunk_hood_panel &&
              interiorDetail?.replaced_trunk_hood_panel !== "No"
                ? interiorDetail?.replaced_trunk_hood_panel_cost
                : null
            }
            files={
              interiorDetail?.replaced_trunk_hood_panel &&
              interiorDetail?.replaced_trunk_hood_panel !== "No"
                ? ["Replaced Trunk Hood Panel"]
                : null
            }
          />
          <DetailItem
            label="Front Cross Member"
            value={interiorDetail?.front_cross_member}
            cost={
              interiorDetail?.front_cross_member &&
              interiorDetail?.front_cross_member !== "Ok"
                ? interiorDetail?.front_cross_member_cost
                : null
            }
            files={
              interiorDetail?.front_cross_member &&
              interiorDetail?.front_cross_member !== "Ok"
                ? ["Front Cross Member"]
                : null
            }
          />
          <DetailItem
            label="Upper Core Support"
            value={interiorDetail?.upper_core_support}
            cost={
              interiorDetail?.upper_core_support &&
              interiorDetail?.upper_core_support !== "Ok"
                ? interiorDetail?.upper_core_support_cost
                : null
            }
            files={
              interiorDetail?.upper_core_support &&
              interiorDetail?.upper_core_support !== "Ok"
                ? ["Upper Core Support"]
                : null
            }
          />
        </Col>
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Core Support"
            value={interiorDetail?.core_support}
            cost={
              interiorDetail?.core_support &&
              interiorDetail?.core_support !== "Ok"
                ? interiorDetail?.core_support_cost
                : null
            }
            files={
              interiorDetail?.core_support &&
              interiorDetail?.core_support !== "Ok"
                ? ["Core Support"]
                : null
            }
          />
          <DetailItem
            label="Rear Wheel House"
            value={interiorDetail?.rear_wheel_house}
            cost={
              interiorDetail?.rear_wheel_house &&
              interiorDetail?.rear_wheel_house !== "Ok"
                ? interiorDetail?.rear_wheel_house_cost
                : null
            }
            files={
              interiorDetail?.rear_wheel_house &&
              interiorDetail?.rear_wheel_house !== "Ok"
                ? ["Rear Wheel House"]
                : null
            }
          />
          <DetailItem
            label="Front Side Member"
            value={interiorDetail?.front_side_member}
            cost={
              interiorDetail?.front_side_member &&
              interiorDetail?.front_side_member !== "Ok"
                ? interiorDetail?.front_side_member_cost
                : null
            }
            files={
              interiorDetail?.front_side_member &&
              interiorDetail?.front_side_member !== "Ok"
                ? ["Front Side Member"]
                : null
            }
          />
          <DetailItem
            label="Front Inside Panel"
            value={interiorDetail?.front_inside_panel}
            cost={
              interiorDetail?.front_inside_panel &&
              interiorDetail?.front_inside_panel !== "Ok"
                ? interiorDetail?.front_inside_panel_cost
                : null
            }
            files={
              interiorDetail?.front_inside_panel &&
              interiorDetail?.front_inside_panel !== "Ok"
                ? ["Front Inside Panel"]
                : null
            }
          />
          <DetailItem
            label="Front Pillar"
            value={interiorDetail?.front_pillar}
            cost={
              interiorDetail?.front_pillar &&
              interiorDetail?.front_pillar !== "Ok"
                ? interiorDetail?.front_pillar_cost
                : null
            }
            files={
              interiorDetail?.front_pillar &&
              interiorDetail?.front_pillar !== "Ok"
                ? ["Front Pillar"]
                : null
            }
          />
          <DetailItem
            label="Center Pillar"
            value={interiorDetail?.center_pillar}
            cost={
              interiorDetail?.center_pillar &&
              interiorDetail?.center_pillar !== "Ok"
                ? interiorDetail?.center_pillar_cost
                : null
            }
            files={
              interiorDetail?.center_pillar &&
              interiorDetail?.center_pillar !== "Ok"
                ? ["Center Pillar"]
                : null
            }
          />
          <DetailItem
            label="Roof Panel"
            value={interiorDetail?.roof_panel}
            cost={
              interiorDetail?.roof_panel && interiorDetail?.roof_panel !== "Ok"
                ? interiorDetail?.roof_panel_cost
                : null
            }
            files={
              interiorDetail?.roof_panel && interiorDetail?.roof_panel !== "Ok"
                ? ["Roof Panel"]
                : null
            }
          />
          <DetailItem
            label="Dash Panel"
            value={interiorDetail?.dash_panel}
            cost={
              interiorDetail?.dash_panel && interiorDetail?.dash_panel !== "Ok"
                ? interiorDetail?.dash_panel_cost
                : null
            }
            files={
              interiorDetail?.dash_panel && interiorDetail?.dash_panel !== "Ok"
                ? ["Dash Panel"]
                : null
            }
          />
          <DetailItem
            label="Floor Cross Member"
            value={interiorDetail?.floor_cross_member}
            cost={
              interiorDetail?.floor_cross_member &&
              interiorDetail?.floor_cross_member !== "Ok"
                ? interiorDetail?.floor_cross_member_cost
                : null
            }
            files={
              interiorDetail?.floor_cross_member &&
              interiorDetail?.floor_cross_member !== "Ok"
                ? ["Floor Cross Member"]
                : null
            }
          />
          <DetailItem
            label="Floor Side Member"
            value={interiorDetail?.floor_side_member}
            cost={
              interiorDetail?.floor_side_member &&
              interiorDetail?.floor_side_member !== "Ok"
                ? interiorDetail?.floor_side_member_cost
                : null
            }
            files={
              interiorDetail?.floor_side_member &&
              interiorDetail?.floor_side_member !== "Ok"
                ? ["Floor Side Member"]
                : null
            }
          />
          <DetailItem
            label="Center Floor Panel"
            value={interiorDetail?.center_floor_panel}
            cost={
              interiorDetail?.center_floor_panel &&
              interiorDetail?.center_floor_panel !== "Ok"
                ? interiorDetail?.center_floor_panel_cost
                : null
            }
            files={
              interiorDetail?.center_floor_panel &&
              interiorDetail?.center_floor_panel !== "Ok"
                ? ["Center Floor Panel"]
                : null
            }
          />
          <DetailItem
            label="Rear Side Member"
            value={interiorDetail?.rear_side_member}
            cost={
              interiorDetail?.rear_side_member &&
              interiorDetail?.rear_side_member !== "Ok"
                ? interiorDetail?.rear_side_member_cost
                : null
            }
            files={
              interiorDetail?.rear_side_member &&
              interiorDetail?.rear_side_member !== "Ok"
                ? ["Rear Side Member"]
                : null
            }
          />
          <DetailItem
            label="Rear Floor Panel"
            value={interiorDetail?.rear_floor_panel}
            cost={
              interiorDetail?.rear_floor_panel &&
              interiorDetail?.rear_floor_panel !== "Ok"
                ? interiorDetail?.rear_floor_panel_cost
                : null
            }
            files={
              interiorDetail?.rear_floor_panel &&
              interiorDetail?.rear_floor_panel !== "Ok"
                ? ["Rear Floor Panel"]
                : null
            }
          />
          <DetailItem
            label="Rear Inside Panel"
            value={interiorDetail?.rear_inside_panel}
            cost={
              interiorDetail?.rear_inside_panel &&
              interiorDetail?.rear_inside_panel !== "Ok"
                ? interiorDetail?.rear_inside_panel_cost
                : null
            }
            files={
              interiorDetail?.rear_inside_panel &&
              interiorDetail?.rear_inside_panel !== "Ok"
                ? ["Rear Inside Panel"]
                : null
            }
          />
          <DetailItem
            label="Rear Cross Member"
            value={interiorDetail?.rear_cross_member}
            cost={
              interiorDetail?.rear_cross_member &&
              interiorDetail?.rear_cross_member !== "Ok"
                ? interiorDetail?.rear_cross_member_cost
                : null
            }
            files={
              interiorDetail?.rear_cross_member &&
              interiorDetail?.rear_cross_member !== "Ok"
                ? ["Rear Cross Member"]
                : null
            }
          />
        </Col>
        {/* Section 2 - Body Damage Assessment & Refurbishment */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Front Body Damage"
            value={vehicleDetail?.front_body_damage}
          />
          <DetailItem
            label="Right Body Damage"
            value={vehicleDetail?.right_body_damage}
          />
          <DetailItem
            label="Left Body Damage"
            value={vehicleDetail?.left_body_damage}
          />
          <DetailItem
            label="Rear Body Damage"
            value={vehicleDetail?.rear_body_damage}
          />
          <DetailItem
            label="Underbody Damage"
            value={vehicleDetail?.underbody_damage}
          />
          <DetailItem
            label="Rust Body Damage"
            value={vehicleDetail?.rust_body_damage}
          />
          <DetailItem
            label="Front Refurbishment Cost"
            value={vehicleDetail?.front_refurbishment_cost}
            type="currency"
          />
          <DetailItem
            label="Right Refurbishment Cost"
            value={vehicleDetail?.right_refurbishment_cost}
            type="currency"
          />
          <DetailItem
            label="Left Refurbishment Cost"
            value={vehicleDetail?.left_refurbishment_cost}
            type="currency"
          />
          <DetailItem
            label="Rear Refurbishment Cost"
            value={vehicleDetail?.rear_refurishment_cost}
            type="currency"
          />
          <DetailItem
            label="Underbody Refurbishment Cost"
            value={vehicleDetail?.underbody_refurishment_cost}
            type="currency"
          />
          <DetailItem
            label="Rust Refurbishment Cost"
            value={vehicleDetail?.rust_refurishment_cost}
            type="currency"
          />
          <DetailItem
            label="Other Refurbishment Cost"
            value={vehicleDetail?.other_refurishment_cost}
            type="currency"
          />
          <DetailItem
            label="Total Refurbishment Cost"
            value={vehicleDetail?.total_refurishment_cost}
            type="currency"
          />

          <DetailItem
            label="Driver Seat"
            value={interiorDetail?.driver_seat}
            cost={
              interiorDetail?.driver_seat &&
              interiorDetail?.driver_seat !== "Ok"
                ? interiorDetail?.driver_seat_cost
                : null
            }
            files={
              interiorDetail?.driver_seat &&
              interiorDetail?.driver_seat !== "Ok"
                ? ["Driver Seat"]
                : null
            }
          />
        </Col>
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Co Driver Seat"
            value={interiorDetail?.co_driver_seat}
            cost={
              interiorDetail?.co_driver_seat &&
              interiorDetail?.co_driver_seat !== "Ok"
                ? interiorDetail?.co_driver_seat_cost
                : null
            }
            files={
              interiorDetail?.co_driver_seat &&
              interiorDetail?.co_driver_seat !== "Ok"
                ? ["Co Driver Seat"]
                : null
            }
          />
          <DetailItem
            label="Rear Seat"
            value={interiorDetail?.rear_seats}
            cost={
              interiorDetail?.rear_seats && interiorDetail?.rear_seats !== "Ok"
                ? interiorDetail?.rear_seats_cost
                : null
            }
            files={
              interiorDetail?.rear_seats && interiorDetail?.rear_seats !== "Ok"
                ? ["Rear Seat"]
                : null
            }
          />
          <DetailItem
            label="Sunroof"
            value={interiorDetail?.sunroof}
            cost={
              interiorDetail?.sunroof && interiorDetail?.sunroof !== "Ok"
                ? interiorDetail?.sunroof_cost
                : null
            }
            files={
              interiorDetail?.sunroof && interiorDetail?.sunroof !== "Ok"
                ? ["Sunroof"]
                : null
            }
          />
          <DetailItem
            label="Wireless Charger"
            value={interiorDetail?.wireless_charger}
            cost={
              interiorDetail?.wireless_charger &&
              interiorDetail?.wireless_charger !== "Ok"
                ? interiorDetail?.wireless_charger_cost
                : null
            }
            files={
              interiorDetail?.wireless_charger &&
              interiorDetail?.wireless_charger !== "Ok"
                ? ["Wireless Charger"]
                : null
            }
          />
          <DetailItem
            label="Cup Holders"
            value={interiorDetail?.cup_holders}
            cost={
              interiorDetail?.cup_holders &&
              interiorDetail?.cup_holders !== "Ok"
                ? interiorDetail?.cup_holders_cost
                : null
            }
            files={
              interiorDetail?.cup_holders &&
              interiorDetail?.cup_holders !== "Ok"
                ? ["Cup Holders"]
                : null
            }
          />
          <DetailItem
            label="Glove Box"
            value={interiorDetail?.glove_box}
            cost={
              interiorDetail?.glove_box && interiorDetail?.glove_box !== "Ok"
                ? interiorDetail?.glove_box_cost
                : null
            }
            files={
              interiorDetail?.glove_box && interiorDetail?.glove_box !== "Ok"
                ? ["Glove Box"]
                : null
            }
          />
          <DetailItem
            label="Front AC"
            value={interiorDetail?.front_ac}
            cost={
              interiorDetail?.front_ac && interiorDetail?.front_ac !== "Ok"
                ? interiorDetail?.front_ac_cost
                : null
            }
            files={
              interiorDetail?.front_ac && interiorDetail?.front_ac !== "Ok"
                ? ["Front AC"]
                : null
            }
          />
          <DetailItem
            label="Rear AC"
            value={interiorDetail?.rear_ac}
            cost={
              interiorDetail?.rear_ac && interiorDetail?.rear_ac !== "Ok"
                ? interiorDetail?.rear_ac_cost
                : null
            }
            files={
              interiorDetail?.rear_ac && interiorDetail?.rear_ac !== "Ok"
                ? ["Rear AC"]
                : null
            }
          />
          <DetailItem
            label="Front Floor Mat"
            value={interiorDetail?.front_floor_mat}
            cost={
              interiorDetail?.front_floor_mat &&
              interiorDetail?.front_floor_mat !== "Ok"
                ? interiorDetail?.front_floor_mat_cost
                : null
            }
            files={
              interiorDetail?.front_floor_mat &&
              interiorDetail?.front_floor_mat !== "Ok"
                ? ["Front Floor Mat"]
                : null
            }
          />
          <DetailItem
            label="Rear Floor Mat"
            value={interiorDetail?.rear_floor_mat}
            cost={
              interiorDetail?.rear_floor_mat &&
              interiorDetail?.rear_floor_mat !== "Ok"
                ? interiorDetail?.rear_floor_mat_cost
                : null
            }
            files={
              interiorDetail?.rear_floor_mat &&
              interiorDetail?.rear_floor_mat !== "Ok"
                ? ["Rear Floor Mat"]
                : null
            }
          />
          <DetailItem
            label="Seat Belt Front"
            value={interiorDetail?.seat_belts_front}
            cost={
              interiorDetail?.seat_belts_front &&
              interiorDetail?.seat_belts_front !== "Ok"
                ? interiorDetail?.seat_belts_front_cost
                : null
            }
            files={
              interiorDetail?.seat_belts_front &&
              interiorDetail?.seat_belts_front !== "Ok"
                ? ["Seat Belt Front"]
                : null
            }
          />
          <DetailItem
            label="Seat Belt Rear"
            value={interiorDetail?.seat_belts_rear}
            cost={
              interiorDetail?.seat_belts_rear &&
              interiorDetail?.seat_belts_rear !== "Ok"
                ? interiorDetail?.seat_belts_rear_cost
                : null
            }
            files={
              interiorDetail?.seat_belts_rear &&
              interiorDetail?.seat_belts_rear !== "Ok"
                ? ["Seat Belt Rear"]
                : null
            }
          />
          <DetailItem
            label="Door Handles Front"
            value={interiorDetail?.door_handles_front}
            cost={
              interiorDetail?.door_handles_front &&
              interiorDetail?.door_handles_front !== "Ok"
                ? interiorDetail?.door_handles_front_cost
                : null
            }
            files={
              interiorDetail?.door_handles_front &&
              interiorDetail?.door_handles_front !== "Ok"
                ? ["Door Handles Front"]
                : null
            }
          />
          <DetailItem
            label="Door Handles Rear"
            value={interiorDetail?.door_handles_rear}
            cost={
              interiorDetail?.door_handles_rear &&
              interiorDetail?.door_handles_rear !== "Ok"
                ? interiorDetail?.door_handles_rear_cost
                : null
            }
            files={
              interiorDetail?.door_handles_rear &&
              interiorDetail?.door_handles_rear !== "Ok"
                ? ["Door Handles Rear"]
                : null
            }
          />
          <DetailItem
            label="Interior Cleaning"
            value={interiorDetail?.interior_cleaning}
            type="array"
            cost={
              interiorDetail?.interior_cleaning &&
              Array.isArray(interiorDetail?.interior_cleaning) &&
              !interiorDetail?.interior_cleaning.includes("Ok")
                ? interiorDetail?.interior_cleaning_cost
                : null
            }
            files={
              interiorDetail?.interior_cleaning &&
              Array.isArray(interiorDetail?.interior_cleaning) &&
              !interiorDetail?.interior_cleaning.includes("Ok")
                ? ["Interior Cleaning"]
                : null
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default Step4DetailsSection;
